module.exports = "<role-edit (roleEdited)=\"refresh()\" #modal></role-edit>\n<br>\n<div *ngFor=\"let role of roles\">\n    <div class=\"card col-sm-12\">\n      <div class=\"card-block\" (click)=\"modal.show(role.id)\">\n        <div class=\"row\">\n          <div class=\"category col-11\"><label>{{role.name}}</label></div>\n          <button type=\"button\" class=\"btn col-1 color\" (click)=\"delete($event,role)\"><i class=\"fa fa-2x fa-trash\"></i>&nbsp;</button>\n        </div>\n      </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/components/role-list/role-list.component.html
// module id = 613
// module chunks = 5